import { X } from "lucide-react";
import type { ReactNode } from "react";
import { Button } from "./ui";

export function ActionModal({
  title,
  description,
  children,
  confirmLabel = "Done",
  wide = false,
  onClose,
  onConfirm,
}: {
  title: string;
  description?: string;
  children?: ReactNode;
  confirmLabel?: string;
  wide?: boolean;
  onClose: () => void;
  onConfirm?: () => void;
}) {
  return (
    <div className="fixed inset-0 z-50 grid place-items-end bg-navy/45 p-0 backdrop-blur-[2px] sm:place-items-center sm:p-4">
      <div className={`max-h-[92vh] w-full overflow-auto rounded-t-2xl border border-line bg-elevated p-5 shadow-soft sm:rounded-2xl ${wide ? "sm:max-w-3xl" : "sm:max-w-xl"}`}>
        <div className="mb-4 flex items-start gap-3">
          <div className="min-w-0 flex-1">
            <h2 className="text-xl font-semibold tracking-[-0.02em] text-ink">{title}</h2>
            {description ? <p className="mt-1 text-sm leading-6 text-secondary">{description}</p> : null}
          </div>
          <button type="button" className="grid h-9 w-9 place-items-center rounded-lg hover:bg-hover" onClick={onClose} aria-label="Close">
            <X className="h-4 w-4" />
          </button>
        </div>
        {children}
        <div className="mt-5 flex justify-end gap-2">
          <Button type="button" variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          {onConfirm ? (
            <Button type="button" onClick={onConfirm}>
              {confirmLabel}
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
